<template>
  <div>
    <div class="row" v-for="(employee, index) in clocks" :key="index">
      <div class="col-md-12">
        <base-button simple block type="warning" v-on:click="showRows('user_' + index)">{{index.split('_').join(' ')}}</base-button>
      </div>
      <div class="col-md-12 ml-auto mr-auto">
        <div class="row" :class="'user_' + index" style="display: none;">
          <div class="col-lg-12 ml-auto mr-auto">
            <blockquote v-for="(row, indexRow) in employee" :key="indexRow" class="blockquote">
              <div class="row">
                <div class="col-lg-8 ml-auto mr-auto">
                  <p class="mb-0"><code style="font-size: 18px" class="text-center text-warning">{{getDate(row.date,row.time_start,row.time_end)}}</code></p>
                </div>
                <base-input class="col-md-2 col-6">
                  <base-checkbox class="mb-3" v-model="row.is_confirm">
                    Confirmed
                  </base-checkbox>
                </base-input>
                <base-input class="col-md-2 col-6">
                  <base-checkbox class="mb-3" v-model="row.is_delete">
                    Deleted
                  </base-checkbox>
                </base-input>
                <base-input class="col-md-4" style="margin-top: -10px" label="Project:">
                  <select v-model="row.project_id" class="form-control">
                    <option v-for="item in projects" :value="item.project_id" :key="item.project_id">{{item.full_name}}</option>
                  </select>
                </base-input>
                <base-input class="col-md-4" style="margin-top: -10px" label="Wage per hour"
                            v-model="row.rate"
                            placeholder="Wage per hour">
                </base-input>
              </div>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {showElement} from "../../plugins/axios";
  export default {
    name: "clocks-table",
    props: ['clocks', 'projects'],
    data(){
      return {};
    },
    methods:{
      timeToAmPm(time){
        let timeValue = 0;
        if (time !== null){
          time = time.split(':');
          if (time.length === 3){
            let hours = Number(time[0]);
            let minutes = Number(time[1]);
            let seconds = Number(time[2]);

            if (hours > 0 && hours <= 12) {
              timeValue = hours;
            } else if (hours > 12) {
              timeValue = hours - 12;
            } else if (hours === 0) {
              timeValue = 12;
            }
            timeValue = (timeValue < 10) ? "0" + timeValue: timeValue;
            timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;  // get minutes
            //timeValue += (seconds < 10) ? ":0" + seconds : ":" + seconds;  // get seconds
            timeValue += (hours >= 12) ? " p.m." : " a.m.";  // get AM/PM
          }
        }
        else{timeValue = "not finished"}
        return timeValue;
      },
      showRows(className){showElement(className)},
      getDate(date, stTime, ndTime){
        const locDate = new Date(date.split('-').join('/') + " ");
        return locDate.toLocaleDateString() + ' ' + this.timeToAmPm(stTime) + ' - ' + this.timeToAmPm(ndTime);
      }
    }
  }
</script>

<style scoped>

</style>
